import { useFormikContext } from 'formik';
import React from 'react';
import { Poppins, Spacer } from 'src/common';
import CheckBox from 'src/components/form/CheckBox';
import { WizardFormValues } from 'src/api/types/wizard';
import { GridContainer, ScenarioForm } from 'src/components/Wizzard/comps';

export const Scenarios = () => {
  const { values, setFieldValue } = useFormikContext<WizardFormValues>();

  return (
    <GridContainer $large $scenarios>
      <Poppins px={14} color="davysGrey">
        Your answers to these questions will allow us to pre-populate your assessment with relevant scenarios.
      </Poppins>
      <Spacer $px={8} />
      <ScenarioForm />
      <Spacer $px={10} />
    </GridContainer>
  );
};
